module.exports = __webpack_public_path__ + "static/media/dndgif1.1da2d41b.gif";